__turbopack_context__.v({
  "SdramaIg": "ShareModal-module__E1wXmG__SdramaIg",
  "closeButton": "ShareModal-module__E1wXmG__closeButton",
  "copied": "ShareModal-module__E1wXmG__copied",
  "copyButton": "ShareModal-module__E1wXmG__copyButton",
  "dramaAbout": "ShareModal-module__E1wXmG__dramaAbout",
  "dramaIg": "ShareModal-module__E1wXmG__dramaIg",
  "dramaSummary": "ShareModal-module__E1wXmG__dramaSummary",
  "dramaSummarySec": "ShareModal-module__E1wXmG__dramaSummarySec",
  "header": "ShareModal-module__E1wXmG__header",
  "mainBox": "ShareModal-module__E1wXmG__mainBox",
  "modalContent": "ShareModal-module__E1wXmG__modalContent",
  "modalOverlay": "ShareModal-module__E1wXmG__modalOverlay",
  "socialIcons": "ShareModal-module__E1wXmG__socialIcons",
});
